
export const downloadCsv = (
    data: Record<string, string>[],
    headers: string[],
    fileName = "data.csv"
  ) => {

    // Check if data is valid and has elements
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.error("No data provided for CSV download");
      return;
    }

    // Check for mismatch between headers and record keys
    const invalidRecord = data.find((record) => Object.keys(record).length !== headers.length);
    if (invalidRecord) {
      console.error("Mismatch between headers and record keys:", invalidRecord);
      return;
    }

    try {
      // Function to escape CSV fields containing special characters (commas, newlines, or quotes)
      const escapeCsvField = (field: any) => {
        if (field === null || field === undefined) {
          return "";
        }

        let fieldStr = field.toString();

        // Check if field contains commas, newlines, or double quotes
        if (fieldStr.includes(",") || fieldStr.includes("\n") || fieldStr.includes("\"")) {
          // Escape double quotes by replacing them with two double quotes
          fieldStr = `"${fieldStr.replace(/"/g, '""')}"`;
        }

        return fieldStr;
      };

      // Generate CSV content
      const headerRow = headers.join(",");
      const rows = data.map(item =>
        headers.map(header => escapeCsvField(item[header] ?? "")).join(",")
      );
      const csvContent = [headerRow, ...rows].join("\n");

      // Create a Blob object and trigger the download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);

      // Append the link, trigger the click event, then remove the link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error("Error generating or downloading CSV:", error);
    }
  };
